// extracted by mini-css-extract-plugin
export default {"mCard":"Gy-z","image":"Hy-z","imageNoBackground":"Iy-z","imageHasCategory":"Jy-z","fullWidth":"Ky-z"};